import { Box, Flex, HStack, Text, VStack, useMediaQuery } from "native-base";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../../utils/fonts";
import { EventPlanDetailsCards } from "../eventPlanDetailsCard";
import { COLORS } from "../../../../../utils/colors";
import { hasPermission } from "../../../../../utils/permission";
import { MOBILE_VIEW_WIDTH } from "../../../../../utils/screens";

export const SightSeeingCards = ({ detail }) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  return detail &&
    detail.length > 0 &&
    (detail[0] !== "" || detail[0] !== "") ? (
    <Box
      mb={"10px"}
      // bg={bg}
      space={3}
      borderRadius={"8px"}
      w={"100%"}
      // p={!hasPermission("VENDOR") && "18px"}
    >
      {!MobileWindow && (
        <Text
          fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT}
          mb={4}
        >
          Sightseeing
        </Text>
      )}

      <EventPlanDetailsCards
        mt="18px"
        bg={MobileWindow ? COLORS.WHITE_COLOR : undefined}
        body={
          <Flex
            // p={!hasPermission("VENDOR") && 2}
            direction="row"
            wrap="wrap"
            space={1}
            paddingRight={"20px"}
            width={"100%"}
          >
            {detail &&
              detail.map((item) => {
                return (
                  <Box
                    bg={
                      MobileWindow
                        ? COLORS.TRAVEL_PARTNERS_CARD_BGCOLOR
                        : COLORS.WHITE_COLOR
                    }
                    py={"4px"}
                    px={"10px"}
                    borderRadius={"10px"}
                    mx={"8px"}
                    mb={3}
                    width={"fit-content%"}
                    maxW={"100%"}
                  >
                    <Text fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}>
                      {item}
                    </Text>
                  </Box>
                );
              })}
          </Flex>
        }
      />
    </Box>
  ) : (
    <></>
  );
};
